export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_COMPANIES_REQUEST",
  SUCCESS: "ADMIN_FETCH_COMPANIES_SUCCESS",
  FAILURE: "ADMIN_FETCH_COMPANIES_FAILURE",

  REQUEST_SINGLE: "ADMIN_FETCH_COMPANY_REQUEST",
  SUCCESS_SINGLE: "ADMIN_FETCH_COMPANY_SUCCESS",
  FAILURE_SINGLE: "ADMIN_FETCH_COMPANY_FAILURE",

  UPDATE_REQUEST: "ADMIN_UPDATE_COMPANY_REQUEST",
  UPDATE_SUCCESS: "ADMIN_UPDATE_COMPANY_SUCCESS",
  UPDATE_FAILURE: "ADMIN_UPDATE_COMPANY_FAILURE",

  CREATE_REQUEST: "ADMIN_CREATE_COMPANY_REQUEST",
  CREATE_SUCCESS: "ADMIN_CREATE_COMPANY_SUCCESS",
  CREATE_FAILURE: "ADMIN_CREATE_COMPANY_FAILURE",

  DELETE_REQUEST: "ADMIN_DELETE_COMPANY_REQUEST",
  DELETE_SUCCESS: "ADMIN_DELETE_COMPANY_SUCCESS",
  DELETE_FAILURE: "ADMIN_DELETE_COMPANY_FAILURE",
}

export interface ICompany {
  id: number;
  created_at: string;
  updated_at: string;
  name: string | null;
}

interface NormalizedEntities {
  [key: string]: ICompany;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}
